import React, { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { faCalendarExclamation } from '@fortawesome/pro-light-svg-icons'

import { useHistory } from 'react-router'
import { FaIcon, LastMinuteListHeader } from '../../App/Components'
import { useLocation, useParams } from '../../Router'

import { useAppSelector } from '../../store/hooks'
import {
  IconTileContainer,
  IconTileIconContainer,
  IconTileText,
} from '../../App/Components/IconTile/style'

type Props = {
  isListView: boolean
}

const tileLinkStyle = {
  appearance: 'none' as const,
  background: 'transparent',
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  textDecoration: 'none' as const,
  color: 'inherit',
  display: 'block' as const,
}

export const LastMinutesItem: React.FC<Props> = ({ isListView }) => {
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation()
  const { establishmentId } = useParams<{ [key: string]: string }>()

  const lastMinutes = useAppSelector((state) => state.lastMinute.list)
  const settings = useAppSelector((state) => state.settings.values)

  const currentPath = location.pathname.replace(/\/+$/, '')
  const isRootPath: boolean =
    currentPath === `/${establishmentId}/menu` ||
    currentPath === `/${establishmentId}/activities`

  const hasLastMinutes: boolean =
    typeof lastMinutes !== 'undefined' && lastMinutes.length > 0 && isRootPath

  if (!hasLastMinutes) {
    return null
  }

  if (isListView) {
    return (
      <LastMinuteListHeader
        key="LastMinutesTile"
        title={t('Last minutes')}
      />
    )
  }

  /*
   * OB-506: absolute path so the URL is portable when copied via
   * right-click "Copy Link Address" / long-press "Copy link".
   */
  const lastMinutesUrl = `/${location.pathname.split('/')[1]}/last-minutes`

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (
      e.defaultPrevented ||
      e.button !== 0 ||
      e.metaKey ||
      e.altKey ||
      e.ctrlKey ||
      e.shiftKey
    ) {
      return
    }
    e.preventDefault()
    history.push(lastMinutesUrl)
  }

  return (
    <IconTileContainer>
      <a href={lastMinutesUrl} onClick={handleClick} style={tileLinkStyle}>
        <IconTileIconContainer highlightcolor={settings?.highlightColor}>
          <FaIcon
            size="3x"
            icon={faCalendarExclamation}
            color={settings?.highlightColor}
          />
        </IconTileIconContainer>
        <IconTileText>{t('Last minutes')}</IconTileText>
      </a>
    </IconTileContainer>
  )
}
